<template>
  <div id="home">
    <div id="head">
      <div id="spacer">
      <h1>Franz Kafka</h1>
      <h4>Gesammelte Werke</h4>
      </div>
    </div>
    <v-divider></v-divider>
    <h3>Empfehlungen</h3>
    <div v-for="post in posts" :key="post.slug">
      <v-card :to="'/' + post.slug">
          <v-card-title class="title">
              <h5 class="tit">{{ post.title }}</h5>
          </v-card-title>
          <v-card-text class="text"><p class="body-1">{{ post.summary }}</p></v-card-text>
      </v-card>
      <v-divider></v-divider>
    </div>
  </div>
</template>

<style scoped>
#head{
    background-color: #2c3e50;
    text-align: center;
}
#spacer > h1, #spacer > h4{
    color: #ecf0f1;
}
#head{
    border-radius: 5px;
}
#spacer{
    padding: 20px;
}
a {
  text-decoration: none; /* no underline */
}
.title{
    padding-bottom: 0px;
}
.text{
    padding-top: 0px;
}
.tit{
    margin: 0px 0px 0px;
}
.blackx{
  color: black;
}
</style>

<script>
  export default {
    name: 'home',
    data: () => ({
      posts: [
        {slug: "romane-das-schlo", title: "Das Schloß", summary: ""},
        {slug: "der-proze", title: "Der Prozeß", summary: ""}
      ]
    }),
    mounted(){
      this.$Progress.finish()
    },
    metaInfo: {
      meta: [
          {
            name: 'description',
            content: 'Kafka'
          }
        ]
    }
  }
</script>